import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "custom-dark-bg rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_2 = { class: "mb-10 text-center" }
const _hoisted_3 = { class: "text-dark mb-3" }
const _hoisted_4 = { class: "text-gray-400 fw-bold fs-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "/media/svg/brand-logos/google-icon.svg",
  class: "h-20px me-3"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "/media/svg/brand-logos/github.svg",
  class: "h-20px me-3"
}, null, -1)
const _hoisted_7 = { class: "d-flex align-items-center mb-10" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom border-gray-300 mw-50 w-100" }, null, -1)
const _hoisted_9 = { class: "fw-bold text-gray-500 fs-7 mx-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom border-gray-300 mw-50 w-100" }, null, -1)
const _hoisted_11 = { class: "row fv-row mb-7" }
const _hoisted_12 = { class: "col-xl-12" }
const _hoisted_13 = { class: "form-label fw-bolder text-dark fs-6" }
const _hoisted_14 = { class: "fv-plugins-message-container" }
const _hoisted_15 = { class: "fv-help-block" }
const _hoisted_16 = { class: "row fv-row mb-7" }
const _hoisted_17 = { class: "col-xl-12" }
const _hoisted_18 = { class: "form-label fw-bolder text-dark fs-6" }
const _hoisted_19 = { class: "fv-plugins-message-container" }
const _hoisted_20 = { class: "fv-help-block" }
const _hoisted_21 = { class: "fv-row mb-7" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "E-mail", -1)
const _hoisted_23 = { class: "fv-plugins-message-container" }
const _hoisted_24 = { class: "fv-help-block" }
const _hoisted_25 = {
  class: "mb-10 fv-row",
  "data-kt-password-meter": "true"
}
const _hoisted_26 = { class: "mb-1" }
const _hoisted_27 = { class: "form-label fw-bolder text-dark fs-6" }
const _hoisted_28 = { class: "position-relative mb-3" }
const _hoisted_29 = { class: "fv-plugins-message-container" }
const _hoisted_30 = { class: "fv-help-block" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex align-items-center mb-3",
  "data-kt-password-meter-control": "highlight"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 bg-secondary bg-active-success rounded h-5px" })
], -1)
const _hoisted_32 = { class: "text-muted" }
const _hoisted_33 = { class: "fv-row mb-5" }
const _hoisted_34 = { class: "form-label fw-bolder text-dark fs-6" }
const _hoisted_35 = { class: "fv-plugins-message-container" }
const _hoisted_36 = { class: "fv-help-block" }
const _hoisted_37 = { class: "fv-row mb-10" }
const _hoisted_38 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_39 = { class: "form-check-label fw-bold text-gray-700 fs-6" }
const _hoisted_40 = {
  href: "/privacy-and-terms",
  class: "ms-1 link-primary"
}
const _hoisted_41 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_42 = { class: "fv-plugins-message-container" }
const _hoisted_43 = { class: "fv-help-block" }
const _hoisted_44 = { class: "text-center" }
const _hoisted_45 = {
  id: "kt_sign_up_submit",
  ref: "submitButton",
  type: "submit",
  class: "btn btn-lg btn-info"
}
const _hoisted_46 = { class: "indicator-label" }
const _hoisted_47 = { class: "indicator-progress" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
      novalidate: "novalidate",
      onSubmit: _ctx.onSubmitRegister,
      id: "kt_login_signup_form",
      "validation-schema": _ctx.registration
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.auth.create_your_account`)), 1),
          _createElementVNode("div", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.auth.already_have_an_account`)) + " ", 1),
            _createVNode(_component_router_link, {
              to: "/sign-in",
              class: "link-primary fw-bolder"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.auth.sign_in`)) + " " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.here`)), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.AuthProvider('google'))),
          class: "btn btn-flex flex-center btn-light btn-lg w-100 mb-5"
        }, [
          _hoisted_5,
          _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.continue_with`)) + " Google ", 1)
        ]),
        _createElementVNode("a", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.AuthProvider('github'))),
          class: "btn btn-flex flex-center btn-light btn-lg w-100 mb-10"
        }, [
          _hoisted_6,
          _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.continue_with`)) + " Github ", 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.or`)), 1),
          _hoisted_10
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.auth.your_full_name`)), 1),
            _createVNode(_component_Field, {
              class: "form-control form-control-lg form-control-solid",
              type: "text",
              placeholder: "",
              name: "name",
              autocomplete: "off"
            }),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_ErrorMessage, { name: "name" })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.auth.your_nick`)), 1),
            _createVNode(_component_Field, {
              class: "form-control form-control-lg form-control-solid",
              type: "text",
              placeholder: "",
              name: "nick",
              autocomplete: "off"
            }),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_ErrorMessage, { name: "nick" })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createVNode(_component_Field, {
            class: "form-control form-control-lg form-control-solid",
            type: "email",
            placeholder: "",
            name: "email",
            autocomplete: "off"
          }),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_ErrorMessage, { name: "email" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.password`)), 1),
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_Field, {
                class: "form-control form-control-lg form-control-solid",
                type: "password",
                placeholder: _ctx.$t(`${_ctx.currentLanguage}.auth.your_super_secret_password`),
                name: "password",
                autocomplete: "off"
              }, null, 8, ["placeholder"]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_ErrorMessage, { name: "password" })
                ])
              ])
            ]),
            _hoisted_31
          ]),
          _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.auth.use_8_or_more_characters_with_a_mix_of_letters_numbers_symbols`)), 1)
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.auth.confirm_password`)), 1),
          _createVNode(_component_Field, {
            class: "form-control form-control-lg form-control-solid",
            type: "password",
            placeholder: _ctx.$t(`${_ctx.currentLanguage}.auth.type_your_password_again`),
            name: "password_confirmation",
            autocomplete: "off"
          }, null, 8, ["placeholder"]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createVNode(_component_ErrorMessage, { name: "password_confirmation" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("label", _hoisted_38, [
            _createVNode(_component_Field, {
              class: "form-check-input",
              type: "checkbox",
              name: "toc",
              value: "1"
            }),
            _createElementVNode("span", _hoisted_39, [
              _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.auth.i_agree_with_the`)) + " ", 1),
              _createElementVNode("a", _hoisted_40, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.auth.terms_and_conditions`)), 1),
              _hoisted_41
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createVNode(_component_ErrorMessage, { name: "toc" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("button", _hoisted_45, [
            _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.auth.become_a_member_of_the_club`)), 1),
            _createElementVNode("span", _hoisted_47, [
              _createTextVNode(" Hacking " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.user_progress.in_progress`)) + "... ", 1),
              _hoisted_48
            ])
          ], 512)
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ]))
}